import { render, staticRenderFns } from "./CreatePackingList.vue?vue&type=template&id=463b05ea&"
import script from "./CreatePackingList.vue?vue&type=script&lang=js&"
export * from "./CreatePackingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports